import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { getSelectOptions, updateComponent, fetchData } from '../../state/actions/componentsActions'
import { connect } from 'react-redux'
import { camelize } from '../../utils'
import { FetchPOSPlan } from '../../state/api'
import { uniqBy } from 'lodash'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'
import MobileDetect from 'mobile-detect'

class Tariffe extends Component {
    constructor(props) {
        super(props)
    }

    componentWillMount() {
        if (
            this.props.component.hasOwnProperty('options') &&
            (this.props.component.values || []).length === 0 &&
            !this.props.component.fetchInProgress
        ) {
            const { dispatch } = this.props
            this.props.component.fetchInProgress = true
            dispatch(getSelectOptions(this.props.component))
        }
    }

    componentDidMount() {
        const { component, dispatch, guid } = this.props
        let url = 'OnboardRequestDetails/FetchPOSPlan';
        let body = { GUID: guid };
        FetchPOSPlan(url, body).then(json => {
            const dbplan = json && json.payLoad && json.payLoad.Plan && json.payLoad.Plan.toUpperCase();
            const planMap = { FLEX: 'flex', FLEXCRS: 'flexCRS', FLATCRS: 'flatCRS', FLEXMINI: 'flexmini' };
            const plan = planMap[dbplan] || 'flat';
            dispatch(updateComponent(component.id, { plan }));
        })
    }
    ChangePOSPlan(){
        const { dispatch,component } = this.props
        let {  plan } = component
        const newplan = plan=== 'flex' || plan==='flexmini' ? 'flat' : 'flex';
        dispatch(updateComponent(component.id, {plan:newplan}));

        // {() => {
        //     const plan = this.component.plan=== 'flex' ? 'flat' : 'flex';
        //     dispatch(updateComponent(component.id, {plan:plan}));
        // }}
    }

    componentWillReceiveProps(nextProps) {
        const { dispatch } = this.props
        if (
            (nextProps.component &&
                this.props.component.values.length === 0 &&
                nextProps.component.values.length >= 0) ||
            (nextProps.component &&
                this.props.component.values.length > 0 &&
                nextProps.component.values.length === 0)
        ) {
            if (!this.props.component.value && !!this.props.component.initialValue) {
                this.props.component.value = this.props.component.initialValue
            }

            if (
                this.props.component.hasOwnProperty('options') &&
                (this.props.component.values || []).length === 0 &&
                !this.props.component.fetchInProgress
            ) {
                this.props.component.fetchInProgress = true
                dispatch(getSelectOptions(this.props.component))
            }
        }
        const { component } = nextProps
        if(component && component.plan && (component.plan==='flex' || (component.plan && component.plan.toUpperCase()==='FLEXCRS') || (component.plan && component.plan.toUpperCase()==='FLEXMINI')) && this.props.component && component.plan!==this.props.component.plan) {
            this.onValueChange(component.plan.toUpperCase()==='FLEXMINI'?'207':'203',component.plan);
        }
    }

    onValueChange(selectedValue,plan){
        const{dispatch, component}= this.props
        if(selectedValue==='203') 
        {
            if(plan==='flex' || (plan && plan.toUpperCase()==='FLEXCRS'))
            {
               dispatch(updateComponent('S2-S2S1D6', { status: ['readonly'],active:true }))
               dispatch(updateComponent('S2-S2S1D2', { status: ['hidden']}))
            }
            else
            {
                dispatch(updateComponent('S2-S2S1D2', { status: ['readonly']}))
                dispatch(updateComponent('S2-S2S1D3', { status: ['hidden'],active:false}))
            }
        }
        else if(selectedValue==='207')
        {
            dispatch(updateComponent('S2-S2S1D3', { status: ['readonly'],active:true }))
            dispatch(updateComponent('S2-S2S1D2', { status: ['hidden'] }))
        }
        dispatch(updateComponent(component.id, { value: selectedValue }))
    }

    renderOptions() {
        const { component } = this.props
        let { values, plan } = component

        let filteredPlans = values.filter(v => ((plan==='flat' || (plan && plan.toUpperCase()==='FLATCRS')) && (v.value==='193' || v.value==='194' || v.value==='204' || v.value==='205')) || ((plan==='flex' || (plan && plan.toUpperCase()==='FLEXCRS')) && v.value==='203') || ((plan==='flexmini' || (plan && plan.toUpperCase()==='FLEXMINI')) && v.value==='207'))

        return filteredPlans.map(v => {
            return (
                <div {...css(this.props.styles.component,  (v.value==='203' || v.value==='207') && this.props.styles['tariffe-hide']/*, this.props.styles['tariffe-component']*/)} >
                    <div {...css(this.props.styles.tariffe,
                       component.status.indexOf('error') > -1 &&
                       this.props.styles['input--invalid'],
                       component.status.indexOf('loading') > -1 &&
                       this.props.styles['input--blink'],
                       !component.value && this.props.styles['input--unset'])} >

                        <div {...css(this.props.styles['tariffe-block'],
                            v.value === component.value ? 
                            this.props.styles['tariffe-block-selected'] : 
                            this.props.styles['tariffe-block-disabled'])} 
                            onClick={()=> this.onValueChange(v.value,plan)}>
                            
                            <span {...css(v.value === component.value ? this.props.styles['tariffe-selected-img'] : '')}></span>
                            <div {...css(this.props.styles['tariffe-currency-vat'])} >
                                <div {...css(this.props.styles['tariffe-currency'],
                                    v.value === component.value ? this.props.styles['tariffe-selected'] : this.props.styles['tariffe-disabled'])} >
                                    {v.currency}
                                </div>
                                <div {...css(this.props.styles['tariffe-vat'])} >{v.vat}</div>
                            </div>
                            <div {...css(this.props.styles['tariffe-per-month'])} >{v.perMonth}</div>
                        </div>

                        <div {...css(this.props.styles['tariffe-desc'])} >{v.desc}</div>
                    </div>
                </div>
            )
        })


    }

    render() {
        const { dispatch, component } = this.props
        let { plan } = component
        const md = new MobileDetect(window.navigator.userAgent)

        return (
            <div>
                {this.renderOptions()}
                <span
                    {...css(
                        this.props.styles.label,
                        component.value !== '' && this.props.styles['label--active'],
                        this.props.isInModal && this.props.styles['label--neutral']
                    )}
                >
                    {component.cleanName}
                </span>
                <small {...css(this.props.styles['error-msg'])}>
                    {camelize(component.errorMessage[0], true, true)}
                </small>
                {/* <a {...css(this.props.styles['tariffe-link'])}
                    onClick={()=>this.ChangePOSPlan()}>
                    Switch to Easy {component.plan === 'flex' ? 'Flat' : 'Flex'}?
                </a> */}
                {(plan === 'flat' || plan === 'flatCRS') && <div className="grayed mt-4">
                    Se sei già in possesso di un <b>codice coupon</b> puoi inserirlo all'ultimo step dopo la firma dei contratti, prima dell'invio della pratica.
                </div>}
            </div>
        )
    }
}

Tariffe.propTypes = {
    widget: PropTypes.object.isRequired,
    component: PropTypes.object.isRequired,
    styles: PropTypes.object.isRequired
}

const mapStateToProps = (state) => {
    const { step } = state
    return step
}

export default connect(mapStateToProps)(withStyles(Styles)(Tariffe))


// WEBPACK FOOTER //
// ./components/tariffe/index.js